'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _reactIntl = require('react-intl');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _AsSeenOn = require('./AsSeenOn.scss');

var _AsSeenOn2 = _interopRequireDefault(_AsSeenOn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  AsSeenOn: {
    displayName: 'AsSeenOn'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/AsSeenOn.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var AsSeenOn = _wrapComponent('AsSeenOn')((_dec = (0, _reactCssModules2.default)(_AsSeenOn2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AsSeenOn, _Component);

  function AsSeenOn() {
    (0, _classCallCheck3.default)(this, AsSeenOn);
    return (0, _possibleConstructorReturn3.default)(this, (AsSeenOn.__proto__ || (0, _getPrototypeOf2.default)(AsSeenOn)).apply(this, arguments));
  }

  (0, _createClass3.default)(AsSeenOn, [{
    key: 'render',
    value: function render() {
      var dtacImage = require('theme/images/dtac.png');
      var e27Image = require('theme/images/e27.png');
      var riseImage = require('theme/images/rise.png');
      var travhqImage = require('theme/images/travhq.png');
      var thaipbsImage = require('theme/images/thaipbs.png');
      var techImage = require('theme/images/tech-in-asia.png');
      return _react3.default.createElement(
        'div',
        { styleName: 'container' },
        _react3.default.createElement(
          'div',
          { styleName: 'inner' },
          _react3.default.createElement(
            'div',
            { styleName: 'as-seen-on' },
            _react3.default.createElement(
              'h2',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.as_seen_on.header' })
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'row-as-seen-on' },
              _react3.default.createElement(
                'div',
                { styleName: 'as-seen-on-container' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'half-as-seen-on' },
                  _react3.default.createElement(
                    'a',
                    { href: 'http://accelerate.dtac.co.th/en/Alumni', target: '_blank', styleName: 'as-seen-link', rel: 'noopener noreferrer' },
                    _react3.default.createElement('img', { src: dtacImage, alt: 'Dtac' })
                  ),
                  _react3.default.createElement(
                    'a',
                    { href: 'https://e27.co/echelon-top100-flow-account-takemetour-win-thailand-qualifier-20150327/', target: '_blank', styleName: 'as-seen-link', rel: 'noopener noreferrer' },
                    _react3.default.createElement('img', { src: e27Image, alt: 'e27' })
                  ),
                  _react3.default.createElement(
                    'a',
                    { href: 'https://riseconf.com/news/500-startups-headed-for-rise', target: '_blank', styleName: 'as-seen-link', rel: 'noopener noreferrer' },
                    _react3.default.createElement('img', { src: riseImage, alt: 'Rise' })
                  )
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'half-as-seen-on' },
                  _react3.default.createElement(
                    'a',
                    { href: 'https://www.travhq.com/industry/startup-feature/travel-sprint-our-pick-of-thailands-7-coolest-travel-startups/', target: '_blank', styleName: 'as-seen-link', rel: 'noopener noreferrer' },
                    _react3.default.createElement('img', { src: travhqImage, alt: 'Travhq' })
                  ),
                  _react3.default.createElement(
                    'a',
                    { href: 'https://youtu.be/t2RwbSfgRmg?t=36m', target: '_blank', styleName: 'as-seen-link', rel: 'noopener noreferrer' },
                    _react3.default.createElement('img', { src: thaipbsImage, alt: 'ThaiPBS' })
                  ),
                  _react3.default.createElement(
                    'a',
                    { href: 'https://www.techinasia.com/dtac-thai-startups-at-tia-sg-2016', target: '_blank', styleName: 'as-seen-link', rel: 'noopener noreferrer' },
                    _react3.default.createElement('img', { src: techImage, alt: 'TECHINASIA' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return AsSeenOn;
}(_react2.Component)) || _class));

exports.default = AsSeenOn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/AsSeenOn.js
// module id = 318
// module chunks = 47